import React from "react";
import { formatNumber } from "src/common";
import { Flex, Text } from 'src/components';
import { colors } from "src/theme";
import { Card } from "./card";

export interface ImportantInfoCardProps {
  price: number;
}

export const ImportantInfoCard = ({ price }: ImportantInfoCardProps) => (
  <Card background={colors.background6} style={{ boxShadow: 'none' }} radius={8} padding={16}>
    <Flex justify="center" align="center" gap={4}>
      <Text type='medium' bold color={colors.text2}>{`${formatNumber(price)}€`}</Text>
      <Text type="medium" color={colors.text2} >{'/mjesečno'}</Text>
    </Flex>
  </Card>
);

